import { render } from "./AdminStackEditDialog.vue?vue&type=template&id=25533d2c"
import script from "./AdminStackEditDialog.vue?vue&type=script&lang=js"
export * from "./AdminStackEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__